import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useBookingSettings() {
  const [timeslotConfig, setTimeslotConfig] = useState(null);
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from('app_settings')
        .select('key, value')
        .in('key', ['timeslot_config', 'holidays']);

      if (data) {
        const cfg = data.find((d) => d.key === 'timeslot_config');
        const hols = data.find((d) => d.key === 'holidays');
        setTimeslotConfig(
          cfg?.value || {
            enabled: false,
            active_slots: [],
            universal_slot: '09:00 AM - 08:00 PM',
          }
        );
        setHolidays(hols?.value || []);
      }
      setLoading(false);
    };
    fetch();
  }, []);

  const getAvailableSlots = () => {
    if (!timeslotConfig) return [];
    if (timeslotConfig.enabled) return timeslotConfig.active_slots || [];
    return [timeslotConfig.universal_slot || '09:00 AM - 08:00 PM'];
  };

  const isHoliday = (dateStr) => {
    return holidays.find((h) => h.date === dateStr) || null;
  };

  // Returns array of valid date strings (today + 2 days), excluding holidays
  const getAvailableDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 0; i <= 2; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      const str = d.toISOString().split('T')[0];
      dates.push(str);
    }
    return dates;
  };

  return {
    timeslotConfig,
    holidays,
    loading,
    getAvailableSlots,
    isHoliday,
    getAvailableDates,
  };
}